import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as yup from "yup";
import { icons } from "../../../icons";
import { HeadLine3 } from "../../typography/styled";
import Button from "../../button";
import Input from "../../input";
import Select from "../../select";
import { clusterSettingsService } from "../../../api";
import { useUi } from "../../../context/ui.context";
import {
  Container,
  HeadWrapper,
  BodyModal,
  Icon,
} from "../create-node-pool/styles";

type ModalProps = {
  closeModalCancel: () => void;
  closeModal: (data?: any) => void;
  dataToEdit?: any;
};

const ADDON_TYPES = [
  { value: "addon", label: "Addon" },
  { value: "network", label: "Network" },
  { value: "driver", label: "Driver" },
];

const CreateClusterAddon: FC<ModalProps> = ({ closeModal, closeModalCancel, dataToEdit }) => {
  const [t] = useTranslation();
  const { viewAlert } = useUi();
  const [loading, setLoading] = useState(false);
  const [loadingComplete, setLoadingComplete] = useState(false);
  const isEdit = !!dataToEdit?.id;

  const onSubmit = (values: any) => {
    setLoading(true);
    const data = {
      name: values.name,
      description: values.description,
      type: values.type,
    };
    const action = isEdit
      ? clusterSettingsService.updateAddon(dataToEdit.id, data)
      : clusterSettingsService.createAddon(data);

    action
      .then(() => {
        setLoadingComplete(true);
        setTimeout(() => {
          closeModal({ success: true });
          setLoading(false);
          setLoadingComplete(false);
        }, 1500);
      })
      .catch((err) => {
        setLoading(false);
        viewAlert({
          severity: "error",
          message: err?.response?.data?.detail || t("ERROR_OCCURRED"),
        });
      });
  };

  const { values, errors, touched, handleSubmit, handleChange, setFieldValue } = useFormik({
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(t("REQUIRED_FIELD")),
      description: yup.string(),
      type: yup.string().required(t("REQUIRED_FIELD")),
    }),
    initialValues: {
      name: dataToEdit?.name || "",
      description: dataToEdit?.description || "",
      type: dataToEdit?.type || "addon",
    },
    onSubmit,
  });

  return (
    <Container>
      <HeadWrapper>
        <HeadLine3 style={{ marginLeft: "10px", marginTop: "10px" }}>
          {isEdit ? t("EDIT_ADDON") : t("CREATE_ADDON")}
        </HeadLine3>
        <Icon onClick={closeModalCancel} src={icons.CloseIcon} />
      </HeadWrapper>
      <BodyModal>
        <Input title={t("NAME")} fieldName="name" value={values.name} handleChange={handleChange} errors={errors} touched={touched} required />
        <Input title={t("DESCRIPTION")} fieldName="description" value={values.description} handleChange={handleChange} errors={errors} touched={touched} isTextArea />
        <Select title={t("TYPE")} data={ADDON_TYPES} selectedValue={values.type} onChange={(val: any) => setFieldValue("type", val)} fieldName="type" errors={errors} touched={touched} required />
        <div style={{ display: "flex", gap: "6px", marginTop: "6px" }}>
          <Button variant="stroke" size="display" customStyles={{ width: "177px", justifyContent: "center" }} onClick={closeModalCancel} title={t("CANCEL")} />
          <Button variant="primary" size="display" loading={loading} loadingComplete={loadingComplete} customStyles={{ width: "177px", justifyContent: "center" }} onClick={handleSubmit} title={isEdit ? t("SAVE") : t("CREATE")} />
        </div>
      </BodyModal>
    </Container>
  );
};

export default CreateClusterAddon;
